import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/bd-mobile-next/app/components/global/PageTheme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/bd-mobile-next/app/components/home/BannerSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/bd-mobile-next/app/components/home/Bdotd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/bd-mobile-next/app/components/home/CategoryGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/bd-mobile-next/app/components/home/QuickMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/bd-mobile-next/app/components/home/RecommendList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/bd-mobile-next/app/components/home/SubscribeBanner.tsx");
;
import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/bd-mobile-next/styles/home/index.module.scss");
